import script from "./LeistungenView.vue?vue&type=script&setup=true&lang=js"
export * from "./LeistungenView.vue?vue&type=script&setup=true&lang=js"

import "./LeistungenView.vue?vue&type=style&index=0&id=6b18bf6f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b18bf6f"]])

export default __exports__